exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".popover_arrow {\n    overflow: visible!important;\n    margin-top: -19px;\n    margin-left: -18px;\n}\n\n.popover_arrow:before {\n    content: '';\n    width: 40px;\n    height: 40px;\n    background-color: #fff;\n    position: absolute;\n    left: 11px;\n    bottom: -5px;\n    -webkit-transform: rotate(45deg);\n        -ms-transform: rotate(45deg);\n            transform: rotate(45deg);\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, .5);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, .5);\n}\n\n.popover_arrow > div {\n    position: relative;\n    background-color: #fff;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/popover.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/popover.css
// module chunks = 0